export default __webpack_public_path__ + "static/media/whatsapp.ffc8a143.svg";